/** 平台通用品牌配置（多小程序共用） */
export const APP_NAME = '小程序运营管理平台'
export const APP_SHORT_NAME = '运营后台'
export const APP_DESC = '多业务小程序统一配置与管理'
